/**
 * Get id by domain
 * @returns int 1 - sikayufo.ru, 2 - shispare.ru
 */
function getId() {
  if (window.location.hostname === 'shispare.ru') {
    return 2;
  }

  return 1;
}

/**
 * Конфиг приложения: доступ к обьекту конфига в приложении через this.$config
 */
export default {
  /**
   * Api
   */
  api: {
    url: {
      crm: '',
      newcrm: 'http://s1-api.sikayufo.ru',
      media: ''
    },
    params: {
      required: {
        k: '738da44267d8c',
        t: 1
      },
      list: {
        add: 'count'
      }
    }
  },
  id: getId(),
}
